export class AuthRequestBnbaccess {
    constructor(
        public id?: string,
        public telephone?: string,
        public uuid?: string,
        public token?: string,
        public tokenExpiration?: any,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/auth-request/auth-request-bnbaccess.model.ts